<template>
    <div>
        <p>{{question.number}}. {{question.title}}</p>
        <p class="question-info">Pola do wpiasnia ilości wydanych gadżetów</p>
        <ul>
            <li>
                <input type="checkbox" disabled/> Czy gadżety zostały wydane
            </li>
        </ul>
        <p v-if="question.dependentQuestion" class="question-info">
            Pytanie zależne od pytania: {{question.dependentQuestion.number}}. {{question.dependentQuestion.title}}
        </p>
    </div>
</template>


<script>

    export default {
        props: ['question'],
        emits: [],
        components: {},

        methods: {
            filterOptions() {
                return this.question.options.filter(o => !o.deleted);
            }
        }
    }
</script>